export default "__VITE_ASSET__Ci_VRy$i__"